import { render } from "./custom-leave.vue?vue&type=template&id=ca037f16"
import script from "./custom-leave.vue?vue&type=script&lang=js"
export * from "./custom-leave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__